import { createBrowserHistory } from 'history'

export const history = createBrowserHistory()
export { authHeader } from "./auth-header";